import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { dateConvert } from "../../../../helpers/dateConvert";
import "../../../../_metronic/_assets/plugins/flaticon2/flaticon.css";
import { FaUserShield } from "react-icons/fa";
import {GoChecklist} from "react-icons/go"
import {FaCalendarAlt} from "react-icons/fa"
import { FaKey } from 'react-icons/fa';

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
});

export default function View(props) {
  const { onClose, usagehistory } = props;
  const {
    employeeEmail,
    campaignName,
    createdDate,
    assetName,
    partnerName,
  } = usagehistory;
  const classes = useStyles();
  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Usage history details</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />
      <div className="drawer-body">
        <Card className={classes.card}>
          <CardHeader
            title="General information"
            className="bg-secondary text-dark h6 p-3"
            disableTypography
          />
          <CardHeader
            avatar={
              <FaUserShield   className="icon-primary"/>
            }
            title={assetName}
            subheader="Asset"
            className="p-3"
          />
            <CardHeader
           avatar={
         <GoChecklist  className="icon-primary"/>
          }
            title={campaignName}
            subheader="Applied Campaign"
            className="p-3"
          />
          <CardHeader
            avatar={
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Address-card.svg"
                )}
                className="icon-primary"
              />
            }
            title={partnerName}
            subheader="Merchant name"
            className="p-3"
          />
          <CardHeader
            avatar={
              <FaCalendarAlt    className="icon-primary icon"/>
            }
            title={createdDate ? dateConvert(createdDate, false) : "-"}
            subheader="Date"
            className="p-3"
          />
          <CardHeader
            avatar={
              <FaKey className="icon-primary icon"/>

            }
            title={employeeEmail}
            subheader="Employee Id"
            className="p-3"
          />
        </Card>
      </div>
    </div>
  );

  return (
    <Drawer {...props} anchor="right" className="drawer--fixed">
      {sideList("right")}
    </Drawer>
  );
}
